
import React, { useEffect, useMemo, useState, Suspense, lazy } from 'react';
import { commonGet } from '../../../services/CommonService';
import { Modal } from 'react-bootstrap';


const ViewCertification =({user}) =>{

    const[certificates,setCertificates] = useState([]);

    useEffect(() => {

        console.log(user);
        getCertificates();

    }, []);

    const getCertificates =async() =>{

        const reqparam ={
            pageno:'-1',
            ptype:'USERCERTIFICATE',
            query:{userid:user.id}

        }

        const EduResponse = await commonGet(reqparam);
        setCertificates(EduResponse.data);
    }


    const[description ,setDescription] =useState(null);
    const [postModal, setPostModal] = useState(false);
    const viewDescription =async(listval) =>{
        setDescription(listval.description);
        setPostModal(true);
    }


    const closemodal = async () => {
        setPostModal(false);
    }

    return(<>
     <div className="col-12">
      <div className="card">
        
        <div className="card-body">
          <div className="table-responsive">
            <div id="job_data" className="dataTables_wrapper">
              <table
                className="display w-100 dataTable "
                id="example5"
                role="grid"
                aria-describedby="example5_info"
              >
                <thead>
                  <tr role="row">
                    <th className="sorting_asc" style={{ width: "277px" }}>
                      Name
                    </th>
                    <th className="sorting" style={{ width: "178px" }}>
                      Year
                    </th>
                    <th className="sorting" style={{ width: "278px" }}>
                      
                    </th>
                   
                    
                  </tr>
                </thead>

                <tbody>
                 

                  {certificates.map(( listValue, index ) => {
                    return (
                      <tr key={index}>
                        <td>{listValue.name}</td>
                        <td>{listValue.year}</td>
                        <button type="button" onClick={()=>viewDescription(listValue)} className="btn btn-info" >View Certificate</button>  
                        
                      </tr>
                    );
                  })}
                 
                </tbody>
               
              </table>
              
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal className="modal fade" size="lg" show={postModal} onHide={setPostModal} >
            <div className="" role="document">
                <div className="">
                    <form >
                        <div className="modal-header">

                            <button type="button" className="btn-close" onClick={closemodal} data-dismiss="modal"></button>
                        </div>
                        {console.log(description, "description")}
                        <div className="modal-body">
                        <img src={description} alt="Red dot" width="100%" />
        

                        </div>
                        {/*<div className="modal-footer">
                              <button type="submit" className="btn btn-primary" >Add</button>  
                              <button type="button" onClick={()=> setPostModal(false)} className="btn btn-danger"> <i className="flaticon-delete-1"></i> Discard</button>      
</div>*/}
                    </form>

                </div>
            </div>
        </Modal>
    </>)
}

export default ViewCertification